// extracted by mini-css-extract-plugin
module.exports = {"thumbs":"Thumb_thumbs__9Xtn-","item":"Thumb_item__3UWTt","remove":"Thumb_remove__1cbw2"};